"use client";
import { useSearchParams } from "next/navigation";

import { useStore, observer } from "../../../../service/mobx";
import ChipFilterMenu from "../../../../component/Chip/Filter/Menu";

function SearchFilterChip({ param, StartIcon, label, options = {}, Menu }) {
  const { device } = useStore();
  const value = useSearchParams().get(param);
  const selected = value !== null;

  return (
    <ChipFilterMenu
      param={param}
      small={device.isPhone}
      selected={selected}
      StartIcon={StartIcon}
      label={
        device.isPhone
          ? param
          : label || (selected ? options[value] || param : param)
      }
      Menu={{ ...Menu, state: { key: param } }}
    />
  );
}

export default observer(SearchFilterChip);
